import type { AssetType } from '~/types';
import FetchPromise from '~/agent/fetch-promise';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { useDefaultMutation } from '~/lib/react-query';

export interface CreateContentParams {
  type: AssetType;
  name: string;
  itemFolderId?: string;
}

export function createContent({
  type,
  name,
  itemFolderId,
}: CreateContentParams): Promise<{ id: string; type: AssetType }> {
  const url = AssetPickerTypes.getCreateItemUrl(type);
  if (!url) {
    return Promise.reject(new Error('Invalid asset type'));
  }

  const typesThatUseTitle: AssetType[] = [
    AssetPickerTypes.GUIDE,
    AssetPickerTypes.SCORM,
    AssetPickerTypes.EVENT_TEMPLATE,
  ];
  const usesTitle = typesThatUseTitle.includes(type);

  const data: {
    item_folder_id?: string;
    title?: string;
    name?: string;
    content_type?: AssetType;
  } = {};

  if (itemFolderId) data.item_folder_id = itemFolderId;
  if (usesTitle) {
    data.title = name;
  } else {
    data.name = name;
  }

  if (window.APP_CONSTANTS.GENERIC_TOP_LEVEL_CONTENT_TYPES.includes(type as any)) {
    data.content_type = type;
  }

  return FetchPromise.post(url, data);
}

export function useCreateContentMutation() {
  return useDefaultMutation(createContent);
}
